'use client';

import Link from 'next/link';
import { toast } from 'react-toastify';
import validator from 'validator';
import { apiCall, showLoader } from '@/app/helper/common_helper';
import { useState } from 'react';
import { useRouter } from 'next/navigation';
import { DynamicIcon } from 'lucide-react/dynamic';
import { Tooltip } from '@mui/material';
import { Eye, EyeOff } from 'lucide-react';

const Signup = () => {
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const router = useRouter();
    const [varificationStatus, setVarificationStatus] = useState(false);

    const handleSignup = async (e : any) => {
        e.preventDefault();

        if(validator.isEmpty(name)){
            toast.error('Name is required.');
            return;
        }
        if(validator.isEmpty(email)){
            toast.error('Email is required.');
            return;
        }
        if(validator.isEmpty(password)){
            toast.error('Password is required.');
            return;
        }

        if (!validator.isEmail(email)) {
            toast.error('Invalid email address.');
            return;
        }
        if (password.length < 3) {
            toast.error('Password must be at least 3 characters.');
            return;
        }
        
        showLoader(true, 'Creating account...');
        const response = await apiCall('POST', 'auth/register', {
            name,
            email,
            password,
            source: 'api'
        });
        console.log(response);
        if (response) {
            if (response.status == 201) {
                if (response.data && response.data.verificationToken) {
                    toast.success('Account created successfully. Please check your email for verification.');
                    setName('');
                    setEmail('');
                    setPassword('');
                    setVarificationStatus(true);
                }else{
                    toast.success('Account created successfully. Please login to continue.');
                    router.push('/login');
                }
            }
        }
        
        showLoader(false);
    }

    return (
        <>
            {!varificationStatus ?
                <>
                    <h3 className="px_auth_title">Signup!</h3>
                    <p className="px_auth_subtitle">Please enter your credentials to signup.</p>
                    <form onSubmit={handleSignup}>
                        <div className="px_input_wrapper">
                            <input className="px_input" value={name} onChange={(e) => setName(e.target.value)} placeholder="Name" required />
                        </div>
                        <div className="px_input_wrapper">
                            <input className="px_input" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email" required />
                        </div>
                        <div className="px_input_wrapper">
                            <input className="px_input" value={password} onChange={(e) => setPassword(validator.trim(e.target.value))} type={`${showPassword ? "text" : "password"}`} placeholder="Password" required />
                            <Tooltip title={`${showPassword ? "Hide" : "Show"}`} arrow placement="top">
                                <span className="px_password_show_hide" onClick={() => setShowPassword(!showPassword)}>{showPassword ? <EyeOff size={16} /> : <Eye size={16} />}</span>
                            </Tooltip>
                        </div>
                        <button className="px_btn px_btn_block !py-3" onClick={(e) => handleSignup(e)}>Create Account</button>
                        <div className="px_auth_footer">
                            <p>Already have an account? <Link href="/login">Login</Link></p>
                        </div>
                    </form>
                </>
                :
                <>
                    <h3 className='px_auth_title'>Verify it&apos;s you!</h3>
                    <p className='px_auth_subtitle'>A verification link has been sent to your email. Please check your inbox and click on the link to verify your account.</p>
                    <div className='px_auth_footer'>
                        <p><Link href="/login" className='px_btn px_btn_block px_btn_outline'><DynamicIcon name='arrow-left' size={16} /> Go to Login</Link></p>
                    </div>
                </>
            }
        </>
    );
}

export default Signup;